import { useCallback } from 'react';
import { normalizeIdioVolSource } from '../dashboardUtils';
import { getRiskCommandsOrThrow } from '../orchestration/riskCommandRef';
import { RISK_INVALIDATION_CAUSES } from '../orchestration/useRiskOrchestrationCommands';

export default function useOptimizerIdioSourceChange({
    optimizerIdioVolSource,
    requestPosSizingContextUpdate,
    setOptimizerIdioVolSource,
    riskCommandsRef,
}) {
    const applyOptimizerIdioVolSourceChange = useCallback(async (nextSource) => {
        const normalizedNextSource = normalizeIdioVolSource(nextSource);
        if (normalizedNextSource === optimizerIdioVolSource) {
            return true;
        }

        setOptimizerIdioVolSource(normalizedNextSource);
        const commands = getRiskCommandsOrThrow(
            riskCommandsRef,
            'useOptimizerIdioSourceChange.applyOptimizerIdioVolSourceChange',
            [
                'invalidateRiskSurface',
                'refreshRiskSurface',
                'refreshSelectedOverview',
            ],
        );

        commands.invalidateRiskSurface({
            cause: RISK_INVALIDATION_CAUSES.IDIO_VOL_SOURCE_CHANGED,
            reason: 'idio_vol_source_change',
        });

        try {
            await commands.refreshRiskSurface({
                reason: 'idio_vol_source_change',
                idioVolSource: normalizedNextSource,
                includeOptimizerSummaries: false,
            });
            await requestPosSizingContextUpdate({
                reason: 'idio_vol_source_change',
                idioVolSource: normalizedNextSource,
            });
        } finally {
            commands.refreshSelectedOverview({ reason: 'idio_vol_source_change' });
        }
        return true;
    }, [
        optimizerIdioVolSource,
        requestPosSizingContextUpdate,
        riskCommandsRef,
        setOptimizerIdioVolSource,
    ]);

    return {
        applyOptimizerIdioVolSourceChange,
    };
}
